import { lazy } from 'react'

const UpgradeRequestPage = lazy(
  () => import('@/presentation/pages/upgrade-request/upgrade-request-page')
)

export const makeUpgradeRequestPage = () => {
  return <UpgradeRequestPage />
}
